import { useState } from "react";
import { Drawer, Button } from "@mui/material";
import { GridApiPremium } from "@mui/x-data-grid-premium";
import { PricetoolLog } from "./PricetoolLog";
import { SupplierStoreDrawer } from "./SupplierStoreDrawer";

interface PricetoolSidebarProps {
  leftSidebarVisible: boolean;
  rightSidebarVisible: boolean;
  onCloseLeftSidebar: () => void;
  onCloseRightSidebar: () => void;
  inventoryGridApiRef: React.RefObject<GridApiPremium | null>;
  outputLog: any[];
  setOutputLog: React.Dispatch<React.SetStateAction<any[]>>;
}

export function PricetoolSidebar({
  leftSidebarVisible,
  rightSidebarVisible,
  onCloseLeftSidebar,
  onCloseRightSidebar,
  inventoryGridApiRef,
  outputLog,
  setOutputLog,
}: PricetoolSidebarProps) {
  const [clearedTimestamp, setClearedTimestamp] = useState<string>("");

  const clearSidebar = (updateTimestamp = false) => {
    setOutputLog([]);
    if (updateTimestamp) {
      setClearedTimestamp(new Date().toLocaleString());
    }
  };

  return (
    <>
      {/* Left Sidebar - Store Links */}
      <Drawer
        variant="temporary"
        anchor="left"
        open={leftSidebarVisible}
        onClose={onCloseLeftSidebar}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          "& .MuiDrawer-paper": {
            width: 100,
            boxSizing: "border-box",
            backgroundColor: "#1e1e1e",
          },
        }}
      >
        <SupplierStoreDrawer inventoryGridApiRef={inventoryGridApiRef} />
      </Drawer>

      {/* Right Sidebar - Pricetool Log */}
      <Drawer
        variant="temporary"
        anchor="right"
        open={rightSidebarVisible}
        onClose={onCloseRightSidebar}
        sx={{
          "& .MuiDrawer-paper": {
            width: 400,
            boxSizing: "border-box",
            backgroundColor: "#2c2c2c",
            overflow: "auto",
          },
        }}
      >
        <Button
          size="small"
          variant="contained"
          sx={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            zIndex: 1000,
            margin: 0,
          }}
          onClick={() => clearSidebar(true)}
        >
          Clear
        </Button>
        <PricetoolLog content={outputLog} clearedTimestamp={clearedTimestamp} />
      </Drawer>
    </>
  );
}
